import React, { useState, useEffect } from "react";
import { FaAngleLeft, FaAngleRight, FaDownload } from "react-icons/fa";
import { postLead } from '../../apis/LeadAPI';


const NivaBupa = () => {
    const [selectedJob, setSelectedJob] = useState(null);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    const handleApplyClick = (job) => {
        setSelectedJob(job);
        setIsDrawerOpen(true);
    };

    const closeDrawer = () => {
        setIsDrawerOpen(false);
        setSelectedJob(null);
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        
        setIsLoading(true); // Set loading state to true
      
        // Get lead data from the form
        const leadData = {
          name: event.target.name.value,
          email: event.target.email.value,
          mobile: event.target.contactNumber.value,
        };
      
        // Call the postLead function with lead data
        const response = await postLead(leadData);
      
        setIsLoading(false); // Reset loading state after the API call
      
        if (response.leadId) {
          alert(response.message);
          closeDrawer();
        } else {
          alert("Somthing went wrong");
        }
      };

    const images = [
        {
            src: "https://www.auraui.com/memeimage/square-image1.png",
            title: "Comprehensive Coverage",
            description: "Niva Bupa’s reassurance 2.0",
        },
        {
            src: "https://www.auraui.com/memeimage/square-image2.png",
            title: "Cashless Network",
            description: "Niva Bupa’s reassurance ",
        },
        
    ];

    const [currentIndex, setCurrentIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        // Detect screen size and set isMobile accordingly
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768); // 768px as breakpoint for mobile
        };

        window.addEventListener("resize", handleResize);
        handleResize(); // Run initially to set state based on the initial screen size

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleNext = () => setCurrentIndex((prev) => (prev + 1) % images.length);
    const handlePrev = () => setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);

    const handleImageClick = (imageSrc) => {
        window.open(imageSrc, "_blank");
    };

    return (
        <>
            <div className="bg-gray-50">
                <div className="bg-darkBlue text-white py-12 px-6 h-[45vh] text-center">
                    <h1 className="text-4xl font-bold pt-20">Niva Bupa</h1>
                    <p className="text-lg mt-2">
                        Affordable, reliable coverage for you and your loved ones.
                    </p>
                </div>
            </div>
            
            {/* Insurance Plan Carousel Section */}
            <div className="relative mt-16 w-full max-w-7xl mx-auto grid lg:grid-cols-2 gap-8 items-center mb-10">
                {/* Right Column: Carousel */}
                <div className="relative lg:order-last">
                    <div className="overflow-hidden">
                        <div
                            className="flex transition-transform duration-500 ease-in-out"
                            style={{
                                transform: `translateX(-${currentIndex * (isMobile ? 100 : 50)}%)`,
                            }}
                        >
                            {images.map((image, index) => (
                                <div key={index} className="w-full sm:w-full md:w-1/2 flex-shrink-0 px-2">
                                    <div className="relative">
                                        <img
                                            src={image.src}
                                            alt={`Slide ${index}`}
                                            className="w-full h-[50vh] md:h-[50vh] object-contain"
                                        />
                                        {/* Title and Description Overlay */}
                                        <div className="absolute bottom-0 left-0 w-full p-4 bg-gradient-to-t from-black to-transparent text-white">
                                            <h3 className="text-lg font-bold">{image.title}</h3>
                                            <p className="text-sm mb-2">{image.description}</p>
                                            {/* Button */}
                                            <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                                <button
                                                    onClick={() => handleApplyClick(image)}
                                                    className="w-full md:w-auto px-3 py-2 text-sm md:text-base font-medium border border-white text-white bg-darkBlue rounded-lg shadow transition-all duration-200"
                                                >
                                                    BUY
                                                </button>
                                                <button
                                                    className="flex items-center justify-center w-full md:w-auto px-4 py-2 text-sm md:text-base font-medium text-blue-600 bg-white border border-blue-600 rounded-lg shadow focus:outline-none transition-all duration-200"
                                                >
                                                    <FaDownload className="mr-2" />
                                                    Download PDF
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Navigation Buttons */}
                    {images.length > 1 && (
                        <>
                            {/* Left Navigation Button */}
                            <button
                                className="absolute top-1/2 left-0 -translate-y-1/2 text-white p-2 rounded-full"
                                onClick={handlePrev}
                            >
                                <FaAngleLeft style={{ fontSize: "25px" }} />
                            </button>

                            {/* Right Navigation Button */}
                            <button
                                className="absolute top-1/2 right-0 -translate-y-1/2 text-white p-2 rounded-full"
                                onClick={handleNext}
                            >
                                <FaAngleRight style={{ fontSize: "25px" }} />
                            </button>

                            {/* Dots Navigation */}
                            <div className="flex justify-center mt-4 space-x-2">
                                {images.map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => setCurrentIndex(index)}
                                        className={`w-3 h-3 rounded-full ${
                                            index === currentIndex ? "bg-blue-600" : "bg-gray-400"
                                        }`}
                                    ></button>
                                ))}
                            </div>
                        </>
                    )}
                </div>

                {/* Left Column: Text Content */}
                <div className="flex flex-col justify-center px-4 md:px-6 lg:px-8 mx-auto max-w-7xl">
                    <h1 className="text-3xl md:text-4xl font-bold text-gray-900">Affordable Coverage</h1>
                    <p className="mt-4 text-base md:text-lg text-gray-700">
                        Choose from a wide variety of health insurance plans that offer flexibility,
                        coverage, and peace of mind. With options for family, individual, and group coverage,
                        we ensure that your health is protected, no matter what.
                    </p>
                </div>
            </div>

            {isDrawerOpen && (
                <>

                    {/* Transparent Background */}
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 z-40"
                        onClick={closeDrawer} // Close the popup when clicking outside
                    ></div>

                    {/* Popup */}
                    <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-11/12 max-w-3xl bg-white shadow-lg rounded-lg z-50 overflow-hidden flex flex-col md:flex-row">

                        <button
                            onClick={() => {
                                closeDrawer(); // Close the popup
                                
                            }}
                            className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-xl"
                        >
                            ✖
                        </button>
                        
                        {/* Left Side: Image */}
                        <div className="w-full md:w-1/3 h-40 md:h-auto bg-cover bg-center" style={{ backgroundImage: `url(https://images.pexels.com/photos/7821911/pexels-photo-7821911.jpeg?auto=compress&cs=tinysrgb&w=600)` }}>
                        </div>

                        {/* Right Side: Form Content */}
                        <div className="w-full md:w-2/3 p-4 md:p-6">
                            <h2 className="text-xl md:text-2xl font-bold mb-2 md:mb-4">{selectedJob.description}</h2>
                            <p className="text-gray-600 mb-4">Please fill out the form to buy this plan</p>
                            <form onSubmit={handleFormSubmit} className="space-y-3 md:space-y-4">
                                <div>
                                    <label htmlFor="name" className="block font-medium text-gray-700">
                                        Name
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        required
                                        className="w-full border rounded-lg p-2 mt-1"
                                        placeholder="Enter your full name"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="email" className="block font-medium text-gray-700">
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        required
                                        className="w-full border rounded-lg p-2 mt-1"
                                        placeholder="Enter your email"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="contactNumber" className="block font-medium text-gray-700">
                                        Contact Number
                                    </label>
                                    <input
                                        type="tel"
                                        id="contactNumber"
                                        name="contactNumber"
                                        required
                                        className="w-full border rounded-lg p-2 mt-1"
                                        placeholder="Enter your contact number"
                                    />
                                </div>
                                <div className="flex flex-col md:flex-row justify-end gap-2">
                                    <button
                                        type="button"
                                        onClick={closeDrawer}
                                        className="w-full md:w-auto px-4 py-2 border rounded-lg text-gray bg-skyBlue hover:bg-gray-100"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        className="w-full md:w-auto px-4 py-2 bg-darkBlue text-white rounded-lg"
                                    >
                                        Submit Application
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default NivaBupa;
